module.exports = __webpack_public_path__ + "img/rullet_g_icon.54551e45.png";